<template>
    <div class="page-center content-load">

        <div class="recuperar-senha" style="display: none;">
            <h3>Recuperação senha</h3>
            <h5 style="display: block; line-height: 130%;">Escolha como deseja recuperar a sua senha:</h5>
            <button v-if="recuperacao.sms" type="button" class="button block-mobile" v-on:click="recuperarSenha(false, 'sms')">
                SMS - {{recuperacao.smsDestinatario}}
            </button>
            <button v-if="recuperacao.email" type="button" class="button block-mobile" v-on:click="recuperarSenha(false, 'email')">
                E-mail - {{recuperacao.emailDestinatario}}
            </button>     
            <a v-on:click="recuperarSenha(false, 'voltar')">Voltar</a>
        </div> 

        <div class="container">
            <div class="row">
                <div class="col-xl-4 col-md-6 col-lg-4 offset-xl-4 offset-md-3 offset-lg-4 animated fadeIn">

                    <center>
                        <img src="static/config/logo.png" style="width: 200px !important; " class="logo">
                    </center>
                </div>
                <div class="col-xl-12 animated fadeIn center">
                    <h4 style="color: var(--theme-color-primary); margin-bottom: 15px; font-size: 1.6em; line-height: 120%; font-weight: bold;">
                        {{$root.config.loginTexto}}
                    </h4>
                </div>
                <div class="col-xl-4 col-md-6 col-lg-4 offset-xl-4 offset-md-3 offset-lg-4 animated fadeIn">
                    <div class="login-register-page">
                        
                        <div class="welcome-text">
                            <h3>
                                <i class="las la-user"></i>
                                Acesse sua conta
                            </h3>
                            <span>Não possui um cadastro?
                                <br>
                                <router-link :to="{'name': 'Cadastro'}" class="button small gray margin-top-5">
                                    <i class="las la-plus"></i>
                                    <b>Cadastre-se aqui</b>
                                </router-link>
                            </span>
                        </div>
                            
                        
                        <form method="post" id="login-form" v-on:submit.prevent="submit" novalidate="">

                            <div class="input-with-icon-left">
                                <i class="las la-user"></i>
                                <the-mask :mask="['###.###.###-##']" type="tel" class="input-text with-border" autocomplete="new-password" v-model="form.doc" placeholder="Informe seu CPF" required />
                            </div>

                            <div class="input-with-icon-left">
                                <i class="las la-lock"></i>
                                <input type="password" class="input-text with-border" autocomplete="new-password" name="senha" id="senha" placeholder="Informe sua senha" v-model="form.senha" required/>
                            </div>

                            <a v-on:click="recuperarSenha" class="forgot-password" v-bind:class="{'disabled': loading.recuperarSenha}" style="font-size: 14px;">Esqueceu sua senha?</a>
                            
                            <button class="button full-width margin-top-10" v-bind:class="{'disabled': loading.submit}" type="submit" form="login-form">
                                <i class="las la-check-circle"></i>
                                <span v-show="!loading.submit">Entrar</span>
                                <span v-show="loading.submit">Entrando</span>
                            </button>     

                            <a class="button block-mobile margin-top-10" v-on:click="$root.back();" style="opacity: 0.7; display: block; text-align: center;">
                                <i class="las la-arrow-left"></i>
                                Voltar
                            </a>

                        </form>


                    </div>

                </div>
            </div>
        </div>
    </div>      
</template>

<script>
export default {
    name: 'Login',
    data () {
        return {
            loading: {
                "recuperarSenha":   false,
                "submit":           false,
            },
            form: {
                "email":            null,
                "tipo":             "",
                "senha":            null
            },
            recuperacao: {

            }            
        }
    },
    methods: {
        recuperarSenha: function(e, metodo) {
            var self            = this;
            console.log("recuperarSenha", e, metodo);
            if (e) e.preventDefault();

            if (metodo == "email") {
                self.form.metodo = "email";
            } else if (metodo == "sms") {
                self.form.metodo = "sms";
            } else if (metodo == "voltar") {
                $(".recuperar-senha").fadeOut();
                $(".page-login").removeClass("recuperar-senha-open");                
                return false;
            }

            self.loading.recuperarSenha = true;
            loading.show();
            axios.post("api/recuperar-senha.php", self.form)
            .then(response => {
                loading.hide();
                self.loading.recuperarSenha = false;
                if (response.data.opcoes) {

                    self.recuperacao = response.data.opcoes;
                    self.$forceUpdate();
                    $(".recuperar-senha").fadeIn(1000);
                    $(".page-login").addClass("recuperar-senha-open");
                } else {
                    console.log("ok", response)
                    alert(response.data.message);
                }
            })
            .catch(error => {
                loading.hide();
                self.loading.recuperarSenha = false;
                alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
            });

        },
        submit: function(e) {
            var self            = this;
            var form            = JSON.parse(JSON.stringify(self.form));
            loading.show();
            if (e) e.preventDefault();
            self.loading.submit = true;
            form.senha          = md5(form.senha);

            axios.post("api/login.php", form)
            .then(response => {
                // self.loading.submit = false;
                if (response.data.user) {
                    self.$root.setUser(response.data.user).then(function() {
                        // self.$router.push({"name": "Dashboard"});
                        setTimeout(function() {
                            location.reload();
                        }, 200);
                    });
                } else {
                    loading.hide();
                }
                // alert(response.data.message);
            })
            .catch(error => {
                loading.hide();
                self.loading.submit = false;
                alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                if (error.response) {
                    if (error.response.data.message == "Você ainda não possui uma conta no aplicativo. Cadastre-se para prosseguir.") {
                        self.$router.push({"name": "Cadastro"});
                    }
                }                
            });

        }        
    },
    mounted: function() {
        loading.hide();
        //this.demonstracao();
    }   
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
   
/*    .current-page-login {
        background-image: url(static/images/img2.jpg);
        background-size: auto 100%;
        background-repeat: no-repeat;
        background-position: 60%;
    }*/
    .page-login #wrapper {
        /*background: rgba(255,255,255,0.8);*/
        background: transparent;
        padding-top: 0px !important;
        padding-bottom: 0px !important;
    }    
    .current-page-login .loading {
        top: 0px !important;
    }
    .page-login #wrapper {
        /*background: rgba(255,255,255,0.7);*/
    }

    .page-login .input-with-icon-left i {
        background: #efefef;
    }
    .page-login .input-with-icon-left i {
        color: #1d9dd9;
    }
    .page-login .container {
        padding-left: 20px;
        padding-right: 20px;
    }
    .logo {
        width: 80%;
        margin-bottom: 5vh;
    }
    .page-login .selo {
        /*position: absolute;*/
        bottom: 0px;
        width: 100%;
        display: block;
        margin-top: 5px;
        text-transform: uppercase;
        font-size: 10px;
        text-align: center;
        letter-spacing: 0px;
        color: #444;
    }
/*    .page-login button {
        background: #59ba92 !important;
    }    
    .page-login .selo i {
        font-size: 14px;
        top: 2px;
        color: #59ba92;
        position: relative;
    }
    .page-login h3 i {
        color: #59ba92;
    }   */    
    .page-login.demonstracao-open .content-load:before {
        content: " ";
        position: fixed;
        top: 0px;
        right: 0px;
        left: 0px;
        bottom: 0px;
        background: rgba(0,0,0,0.5);
        z-index: 1;
    }
    .page-login .demonstracao {
        position: fixed;
        background: #efefef;
        left: 10%;
        right: 10%;
        /*bottom: 10%;*/
        top: 10vh;
        padding: 20px;
        z-index: 100 !important;
        text-align: center;
        border-radius: 6px;
    }
    .page-login .demonstracao h3 {
        margin-bottom: 20px;
    }
    .page-login .demonstracao h5 {
        margin-bottom: 20px;
    }
    .page-login .demonstracao .button {
        margin-bottom: 10px;
    }
    .page-login .input-with-icon-left input {
        text-align: center;
        font-size: 19px;
        padding-left: 0px !important;
        padding-right: 0px !important;
    }

    .page-login.recuperar-senha-open .content-load:before {
        content: " ";
        position: fixed;
        top: 0px;
        right: 0px;
        left: 0px;
        bottom: 0px;
        background: rgba(0,0,0,0.5);
        z-index: 1;
    }
    .page-login .recuperar-senha {
        position: fixed;
        background: #efefef;
        left: 10%;
        right: 10%;
        /*bottom: 10%;*/
        top: 20vh;
        padding: 20px;
        z-index: 100 !important;
        text-align: center;
        border-radius: 6px;
    }
    .page-login .recuperar-senha h3 {
        margin-bottom: 20px;
    }
    .page-login .recuperar-senha h5 {
        margin-bottom: 20px;
    }
    .page-login .recuperar-senha a {
        color: #333;
    }
    .page-login .recuperar-senha .button {
        margin-bottom: 10px;
    }     
</style>



// WEBPACK FOOTER //
// src/components/Login.vue